import React, { useEffect, useRef } from "react";
import { Grid, Button, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";

const Step_5_Delegation = ({
  signedDocument,
  setSignedDocument,
  delegation,
  downloadDelegation,
  uploadDocumentSigned,
  errors,
  setErrors,
  deleteDocument,
}) => {
  const delegationInputRef = useRef();

  const hasError = errors.includes("signedDocument");

  useEffect(() => {
    if (delegation?.signedDocument && !signedDocument) {
      const signedDelegation = {
        name: delegation.signedDocument.split("/").pop(),
        url: `${process.env.REACT_APP_API_ENDPOINT}${delegation.signedDocument}`,
      };
      setSignedDocument(signedDelegation);
    }
  }, [delegation?.signedDocument]);

  const removeFieldError = (field) => {
    if (errors.includes(field)) {
      const newErrors = errors.filter((e) => e !== field);
      setErrors(newErrors);
    }
  };

  const handleDelegationClick = () => {
    delegationInputRef.current.click();
  };

  const handleDelegationChange = async (event) => {
    const file = event.target.files[0];

    if (file) {
      removeFieldError("signedDocument");
      setSignedDocument(file);
      try {
        await uploadDocumentSigned([file]);
      } catch (error) {
        console.error(error);
        setSignedDocument(null);
        if (delegationInputRef.current) {
          delegationInputRef.current.value = null;
        }
      }
    }
  };

  const handleRemoveDelegationFile = async () => {
    try {
      await deleteDocument("signedDocument");
      setSignedDocument(null);

      if (delegationInputRef.current) {
        delegationInputRef.current.value = null;
      }
    } catch (error) {
      console.error("Errore", error);
    }
  };

  return (
    <Grid container>
      <Grid item xs={12} className="container-steps">
        <Typography className="title-steps">
          Scarica la delega e allega la scansione firmata
        </Typography>

        <Typography className="text-steps" style={{ marginTop: "10px" }}>
          Clicca{" "}
          <a onClick={downloadDelegation} className="link" href="#">
            QUI
          </a>{" "}
          per scaricare la delega. Quindi{" "}
          <span style={{ fontWeight: "bold" }}>
            stampala, firmala a penna e ricarica la scansione
          </span>{" "}
          tramite il bottone sottostante.
        </Typography>

        <Grid
          container
          item
          xs={12}
          md={8}
          sx={{
            mt: 3,
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <input
            type="file"
            accept="image/*,application/pdf"
            style={{ display: "none" }}
            ref={delegationInputRef}
            onChange={handleDelegationChange}
          />

          <Button
            onClick={handleDelegationClick}
            variant="outlined"
            className={
              hasError
                ? "button-bg-empty-document-error"
                : "button-bg-empty-document"
            }
            style={{ width: "180px" }}
          >
            <Typography className="color-grey">
              Carica delega firmata
            </Typography>
          </Button>

          {signedDocument && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: "-5px",
              }}
            >
              <Typography sx={{ fontSize: "14px", maxWidth: "200px" }}>
                {signedDocument.name}
              </Typography>

              <Button
                onClick={handleRemoveDelegationFile}
                className="color-grey"
                sx={{
                  minWidth: "auto",
                  padding: "2px",
                  marginLeft: "3px",
                  backgroundColor: "transparent",
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: "transparent",
                    boxShadow: "none",
                  },
                }}
              >
                <Close style={{ color: "#5b5b5b" }} fontSize="small" />
              </Button>
            </div>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Step_5_Delegation;
